export const IP_DATA_CO_KEY =
  '7c7a3d8e1b13411beaad06748aa4921ee558e6990d75fcaa1ab6062a';
